const SOURCES = [
  'SEC EDGAR',
  'Companies House',
  'GitHub',
  'Domain & DNS',
  'Your own data',
];

const STATS = [
  { num: 'A·98%', lbl: 'Data-quality grade on every assessment' },
  { num: '4', lbl: 'Open calls surfaced this quarter, ranked' },
  { num: '25', lbl: 'Typed actions ready in the hub' },
];

function Tick() {
  return (
    <svg
      className="h-4 w-4 flex-none text-signal"
      viewBox="0 0 20 20"
      aria-hidden="true"
    >
      <path
        d="M4 10l4 4 8-9"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Sources() {
  return (
    <section id="sources" className="bg-bg-raised py-24 sm:py-28">
      <div className="container-page">
        <div className="mb-12 max-w-[60ch]">
          <p className="eyebrow mb-4">Grounded in real sources</p>
          <h2 className="text-display-md leading-[1.12]">
            Evidence you can trace, from sources you can stand behind.
          </h2>
          <p className="mt-4 text-[1.05rem] text-ink-muted">
            Claros attributes every signal to where it came from. Company-level,
            minimised, and gated — nothing runs silently, and unsourceable
            dimensions are named in the verdict.
          </p>
        </div>

        <div className="flex flex-wrap gap-3">
          {SOURCES.map((s) => (
            <span
              key={s}
              className="flex items-center gap-2.5 rounded-[11px] border border-border bg-bg-surface px-4 py-2.5 text-[14px] text-ink-primary"
            >
              <Tick />
              {s}
            </span>
          ))}
          <span className="flex items-center gap-2.5 rounded-[11px] border border-border bg-bg-surface px-4 py-2.5 text-[14px] text-ink-primary">
            App reviews
            <span className="font-mono text-[10px] tracking-[0.07em] text-ink-faint">
              CONSENTED
            </span>
          </span>
        </div>

        <div className="mt-14 grid gap-7 sm:grid-cols-3">
          {STATS.map((s) => (
            <div key={s.lbl}>
              <div className="font-serif text-[2.5rem] font-medium leading-none tabular-nums text-ink-primary">
                {s.num}
              </div>
              <div className="mt-2.5 text-[13.5px] text-ink-muted">{s.lbl}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
